import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {actions} from "../redux";

class OIDCValidate extends Component {
    componentDidMount() {
        document.title = 'Logistic GPS Tracker | Login';
        if (!this.props.loggedIn) {
            this.props.token().then((data) => {
                console.log(data);
                this.props.history.push('/');
            });
        } else {
            this.props.history.push('/');
        }
    }

    render() {
        const {loggedIn, location} = this.props;
        const redir = loggedIn ? (
            location.state ? (
                <Redirect to={location.state.from}/>
            ) : (
                <Redirect to="/"/>
            )
        ) : null;
        return (
            <React.Fragment>
                {redir}
                <div className="loading2">
                    <div className="lds-grid">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <br/>
                    <b>Now Loading ...</b>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (store) => ({
    loggedIn: store.auth.loggedIn
});
const mapDispatchToProps = (dispatch) => ({
    token: () => dispatch(actions.token())
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OIDCValidate);
